import { gql } from '@apollo/client';

const NOTIFICATION_FIELDS = `
  fragment NotificationFields on Notification {
    id
    body
    resourceType
    resourceId
    resourcePath
    createdAt
    createdByName
    prefix
    custom
  }
`;

const USER_NOTIFICATION_FIELDS = `
  ${NOTIFICATION_FIELDS}
  fragment UserNotificationFields on UserNotification {
    id
    viewedAt
    hiddenAt
    notification {
      ...NotificationFields
    }
  }
`;

export const RESOURCE_NOTIFICATIONS = gql`
  ${NOTIFICATION_FIELDS}
  query NoUserLogResourceNotifications(
    $resourceType: String!
    $resourceId: ID!
    $field: String
    $sellerId: ID
  ) {
    resourceNotifications(
      resourceType: $resourceType
      resourceId: $resourceId
      field: $field
    ) {
      ...NotificationFields
    }
    fieldDeltas(
      resourceType: $resourceType
      resourceId: $resourceId
      field: $field
    ) {
      id
      action
      userDescription
      createdAt
      fields {
        name
        oldValue
        newValue
      }
    }
    mentionUsers(
      sellerId: $sellerId
    ) {
      id
      name
      organization
    }
  }
`;

export const CREATE_NOTIFICATION = gql`
  mutation CreateNotification(
    $resourceType: String!
    $resourceId: ID!
    $field: String
    $body: String!
  ) {
    createNotification(
      resourceType: $resourceType
      resourceId: $resourceId
      field: $field
      body: $body
    ) {
      errors { path, message }
    }
  }
`;

export const CURRENT_USER_NOTIFICATIONS = gql`
  ${USER_NOTIFICATION_FIELDS}
  query CurrentUserNotifications(
    $sellerUserId: ID!
    $limit: Int!
    $offset: Int!
  ) {
    currentUserNotifications(
      sellerUserId: $sellerUserId
      limit: $limit
      offset: $offset
    ) {
      ...UserNotificationFields
    }
  }
`;

export const USER_NOTIFICATION_UPDATED = gql`
  ${USER_NOTIFICATION_FIELDS}
  subscription UserNotificationUpdated (
    $sellerUserId: ID
  ) {
    userNotificationUpdated(
      sellerUserId: $sellerUserId
    ) {
      userNotification {
        ...UserNotificationFields
      }
    }
  }
`;

export const CURRENT_USER_NOTIFICATION_COUNTS = gql`
  query CurrentUserNotificaationCounts($sellerUserId: ID!) {
    currentUserNotificationCounts(sellerUserId: $sellerUserId) {
      unviewed
      visible
    }
  }
`;

export const USER_NOTIFICATION_COUNTS_UPDATED = gql`
  subscription UserNotificationCountsUpdated($sellerUserId: ID!) {
    userNotificationCountsUpdated(sellerUserId: $sellerUserId) {
      unviewed
      visible
    }
  }
`;

export const UPDATE_USER_NOTIFICATION = gql`
  ${USER_NOTIFICATION_FIELDS}
  mutation UpdateUserNotification(
    $id: ID!
    $viewed: Boolean
    $hidden: Boolean
  ) {
    updateUserNotification(
      id: $id
      viewed: $viewed
      hidden: $hidden
    ) {
      userNotification {
        ...UserNotificationFields
      }
    }
  }
`;

export const UPDATE_ALL_USER_NOTIFICATIONS = gql`
  mutation UpdateUserNotification(
    $viewed: Boolean
    $hidden: Boolean
  ) {
    updateAllUserNotifications(
      viewed: $viewed
      hidden: $hidden
    ) {
      errors { path, message }
    }
  }
`;
